// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2poI8","col":"styles_col__3CFjg"};